import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import {
    useAppDispatch,
    useAppSelector,
    ticketInfoSelector,
    ticketPageNumberSelector,
    setTicketInfo,
    useGetTicketQuery,
} from '../../../app/store';

const useTicketFetchData = () => {
    const { ticketId } = useParams();
    const dispatch = useAppDispatch();
    const ticketPageNumber = useAppSelector(ticketPageNumberSelector);
    const ticketInfo = useAppSelector(ticketInfoSelector);

    const {
        data,
        isFetching: loadingTicketData,
        isSuccess: successTicketData,
    } = useGetTicketQuery(Number(ticketId), {
        skip: !ticketId || ticketPageNumber === 1,
    });

    useEffect(() => {
        if (successTicketData && !loadingTicketData) {
            const newMessages = data?.message?.items || [];

            if (ticketPageNumber > 1) {
                // for new page and message loading
                if (ticketInfo?.message) {
                    dispatch(
                        setTicketInfo({
                            ...ticketInfo,
                            message: {
                                ...ticketInfo.message,
                                items: [
                                    ...ticketInfo.message.items,
                                    ...newMessages,
                                ],
                                pagination: {
                                    ...ticketInfo.message.pagination,
                                    current_page: ticketPageNumber,
                                },
                            },
                        }),
                    );
                }
            }
        }
    }, [data, successTicketData, loadingTicketData, ticketPageNumber]);

    return { ticketInfo, loadingTicketData, successTicketData };
};

export default useTicketFetchData;
